module.exports = __webpack_public_path__ + "static/pingAn-d7583dcbb3e96440d313e276f2ad5ac3.jpg";